"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.X_SSKY_NARRATION_SERVICE_CACHE_HEADER = exports.BatchCreateStatusStage = exports.BATCH_ITEM_UNIQUE_TRANSACTION_ID_FIELD = exports.ServiceStatus = exports.NarrationServiceErrorCode = void 0;
/**
 * Narration-service error codes.
 * Note: When adding a new code, think of whether it should be retried upon or not. If yes, handle it in {@link narrationService} textToSpeechWithRetries()
 */
var NarrationServiceErrorCode;
(function (NarrationServiceErrorCode) {
    NarrationServiceErrorCode["RateLimitExceeded"] = "RateLimitExceeded";
    NarrationServiceErrorCode["ServiceError"] = "ServiceError";
    NarrationServiceErrorCode["ContentNotAllowed"] = "ContentNotAllowed";
    NarrationServiceErrorCode["TimeoutError"] = "ServiceTimeoutError";
    NarrationServiceErrorCode["UnexpectedError"] = "UnexpectedError";
    NarrationServiceErrorCode["MaxRetriesError"] = "MaxRetriesError";
    NarrationServiceErrorCode["NoItemsInBatch"] = "NoItemsInBatch";
    NarrationServiceErrorCode["InvalidRequest"] = "InvalidRequest";
    NarrationServiceErrorCode["BatchError"] = "BatchError";
    NarrationServiceErrorCode["BatchPollingError"] = "BatchPollingError"; // No retry
})(NarrationServiceErrorCode || (exports.NarrationServiceErrorCode = NarrationServiceErrorCode = {}));
var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["NOT_EXIST"] = "n/a";
    ServiceStatus["QUEUED"] = "queued";
    ServiceStatus["PENDING"] = "pending";
    ServiceStatus["READY"] = "ready";
    ServiceStatus["ERROR"] = "error";
})(ServiceStatus || (exports.ServiceStatus = ServiceStatus = {}));
exports.BATCH_ITEM_UNIQUE_TRANSACTION_ID_FIELD = "uniqueTransactionIdInBatch";
var BatchCreateStatusStage;
(function (BatchCreateStatusStage) {
    BatchCreateStatusStage["REQUEST_ARRIVED"] = "REQUEST_ARRIVED";
    BatchCreateStatusStage["NARRATION_SERVICE"] = "NARRATION_SERVICE";
})(BatchCreateStatusStage || (exports.BatchCreateStatusStage = BatchCreateStatusStage = {}));
exports.X_SSKY_NARRATION_SERVICE_CACHE_HEADER = "x-ssky-narration-service-cache";
//# sourceMappingURL=types.js.map